import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { exportNetworkElementConfiguration } from '@api/manageNetworkElementConfigurations';

import { IId } from '@interfaces/common/common';

import { ESnackbarTypes } from '@enums/common';

import { NETWORK_ELEMENT_CONFIGURATION_EXPORT } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateExportNetworkElementConfigurationReturned {
	exportNetworkElementConfiguration: UseMutateFunction<any, any, IId<string>, any>;
}

export const useMutateExportNetworkElementConfiguration = (): IUseMutateExportNetworkElementConfigurationReturned => {
	const dispatch = useAppDispatch();

	const { mutate } = useMutation<IId>({
		mutationKey: [NETWORK_ELEMENT_CONFIGURATION_EXPORT],
		mutationFn: exportNetworkElementConfiguration,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.exportConfigurationComparisonSuccess,
				type: ESnackbarTypes.success,
			}));
		},
	});

	return { exportNetworkElementConfiguration: mutate };
};
